webpackJsonp([264507526460530],{

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Company = function (_Component) {
	    _inherits(Company, _Component);
	
	    function Company() {
	        _classCallCheck(this, Company);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    Company.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'company-section-container' },
	            _react2.default.createElement(
	                'div',
	                { className: 'header-with-gradient' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'details-head' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'head' },
	                        'Company'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'details' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'head' },
	                    'We help people navigate digital workplaces through process management and automation'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Hubbler is a one-of-a-kind SaaS product company helping enterprises manage, digitize, automate and optimize business processes with ease. We enable the development of customizable digital business applications with simple, user-friendly automation solutions.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    ' Founded in 2016, the company has led to the successful digital transformation of 20+ SME and large customers across industry verticals and functions. '
	                )
	            ),
	            _react2.default.createElement('div', { className: 'company-image' }),
	            _react2.default.createElement(
	                'div',
	                { className: 'company-info' },
	                _react2.default.createElement('div', { className: 'image' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'head' },
	                        'Designing a people-first workplace'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Hubbler\u2019s mission is to design solutions for people. We embrace a people-first workplace strategy to help collaborate better, engage efficiently, and manage productivity. Hubbler introduces the digital workforce to a seamless, code-free, plug-and-play experience of app development. '
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'company-info reverse' },
	                _react2.default.createElement('div', { className: 'image' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'head' },
	                        'Building a smart digital workplace'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'With over 200+ ready-to-use apps and services, Hubbler\u2019s platform is a powerful tool that integrates workflows, communications and analytics modules for enterprises of any size. Create your own app or pick and customize from our range of pre-built apps for quick deployment and integration with your existing and future systems and data sources.  '
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'information-content' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'information-content-sub' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'head' },
	                        'We\u2019re changing how enterprises manage their business processes'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'At Hubbler, we are building transformative collaborative tools to build better teams, connect people, and make processes more efficient. Our tools help enterprises automate and scale in a jiffy \u2013 fast tracking growth and development.'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'join-team' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'head' },
	                    'Join our team'
	                ),
	                _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    { className: 'bt', to: '/career/?view=openPositions' },
	                    'See Open Positions'
	                )
	            )
	        );
	    };
	
	    return Company;
	}(_react.Component);
	
	exports.default = Company;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-company-aboutus-js-22b6130083f837f8b969.js